interface Api {
  url: string;
}

interface Auth {
  clientId: string;
  authority: string;
  apiScope: string;
}

interface Env {
  name: string;
  production: boolean;
  api: Api;
  auth: Auth;
  serviceWorker: boolean;
  offlineRecoveryRetryIntervalMs?: number;
}

type EnvName = 'local' | 'dev' | 'test' | 'prod';
//26b749f6-8c72-44e3-bbde-ae3de07b4206
const envData = {
  default: {
    production: false,
    auth: {
      clientId: '386fac73-518a-4d41-9a9e-667ece6fdfdb',
      authority: 'https://login.microsoftonline.com/26b749f6-8c72-44e3-bbde-ae3de07b4206',
      apiScope: 'api://8d152336-8973-42eb-9219-a6fc2a138b32/api.access',
    },
    offlineRecoveryRetryIntervalMs: 10_000,
    name: 'Local',
  },
  envSpecificData: {
    local: {
      api: {
        url: 'http://localhost:8080/api',
      },
      serviceWorker: true,
    },
    dev: {
      api: {
        url: 'https://dev.dwo.akersolutions.com/api',
      },
      serviceWorker: true,
      name: 'dev',
    },
    test: {
      api: {
        url: 'https://test.dwo.akersolutions.com/api',
      },
      production: true,
      serviceWorker: true,
      name: 'test',
    },
    prod: {
      api: {
        url: 'https://dwo.akersolutions.com/api',
      },
      production: true,
      auth: {
        clientId: 'f28f204c-7ee3-467a-951e-5be5afd9a99a',
        authority: 'https://login.microsoftonline.com/26b749f6-8c72-44e3-bbde-ae3de07b4206',
        apiScope: 'api://bba5bad6-44fb-40e8-a98d-19b3c20501d6/api.access',
      },
      serviceWorker: true,
      name: 'prod',
    },
  },
  getWithSpecificData(envName: EnvName): Env {
    return {
      ...this.default,
      ...this.envSpecificData[envName],
    };
  },
  get(): Env {
    const hostname = window.location.hostname;

    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return this.getWithSpecificData('local');
    }

    if (hostname.includes('dev')) {
      return this.getWithSpecificData('dev');
    }

    if (hostname.includes('test')) {
      return this.getWithSpecificData('test');
    }

    return this.getWithSpecificData('prod');
  },
};

export const env = (() => {
  const instance = envData.get();
  return {
    get: () => instance,
  };
})();
